export default __webpack_public_path__ + "static/media/medicalTestIcon.755add13.svg";